import { render, staticRenderFns } from "./ExportElementButton.vue?vue&type=template&id=52fba68f&"
import script from "./ExportElementButton.vue?vue&type=script&lang=js&"
export * from "./ExportElementButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports